@if (showPCPModal) {
  <modal
    [config]="pcpModalConfig"
    [condition]="showPCPModal"
    (cancel)="togglePCPModal.emit()"
    class="ProviderSearchModal"
  >
    <div body class="ProviderSearchModal__Body">
      @if (asideHeaderConfig.showAsideHeader) {
        <header class="ProviderSearchModal__Header">
          <h2
            class="ProviderSearchModal__HeaderTitle t-bold"
            data-test-id="providerSearchModalHeader"
            [innerHTML]="asideHeaderConfig.header"
          ></h2>
          <span
            class="ProviderSearchModal__HeaderSubTitle t-data"
            data-test-id="providerSearchModalSubHeader"
            [innerHTML]="asideHeaderConfig.subHeader"
          ></span>
        </header>
      }
      @for (member of members; track member; let i = $index) {
        <section
          class="ProviderSearchModal__Section u-flex"
          (click)="selectConsumer(members, i)"
          [ngClass]="{
            SelectPCP: member.isMemberSelected,
            PCPSelected: member.isPCPSelected,
          }"
        >
          <div class="ConsumerInfo u-flex">
            <div class="u-flex">
              <div class="BulletContainer">
                @if (member.isMemberSelected && !member.isPCPSelected) {
                  <span
                    class="NumberedBullet--Active"
                    [data-test-id]="'selectedMemberNumber_' + i"
                    [innerHTML]="i + 1"
                  ></span>
                }
                @if (!member.isPCPSelected && !member.isMemberSelected) {
                  <span
                    class="NumberedBullet--Inactive"
                    [data-test-id]="'unselectedMemberNumber_' + i"
                    [innerHTML]="i + 1"
                  ></span>
                }
                @if (member.isPCPSelected) {
                  <i class="icon icon--medium" data-test-id="checkedCircleIcon"
                    >check_circle</i
                  >
                }
              </div>
              <div class="ConsumerContainer">
                <div class="u-flex PersonalDetails">
                  <h6
                    class="SubscriberName t-bold"
                    [innerHTML]="getMemberName(member)"
                    [data-test-id]="'memberName_' + i"
                  ></h6>
                  <span
                    class="SubscriberDOB t-data"
                    [innerHTML]="member.date_of_birth | date: 'MM/dd/yyyy'"
                    [data-test-id]="'memberDob_' + i"
                  ></span>
                </div>
                <div class="ProviderDetails">
                  @if (!member.isPCPSelected) {
                    <p
                      class="ProviderDetails__Name"
                      [innerHTML]="getProviderDetail(member)"
                      [data-test-id]="'unSelectedProviderName' + i"
                    ></p>
                  }
                  @if (member.isPCPSelected) {
                    <div class="SelectedProviderContainer">
                      <div class="SelectedProviderDetails">
                        <span
                          class="SelectedProviderDetails__Name t-bold"
                          [innerHTML]="selectedProviderName(member)"
                          [data-test-id]="'selectedProviderName' + i"
                        ></span>
                        <span
                          class="SelectedProviderDetails__PrimarySpecialty t-data"
                          [innerHTML]="
                            member.selectedProvider.primary_specialty
                          "
                          [data-test-id]="'selectedProviderSpecialty' + i"
                        ></span>
                      </div>
                      <i
                        (click)="removePCP(member)"
                        class="icon icon--medium icon--pointer"
                        [data-test-id]="'deleteSelectedProviderIcon' + i"
                        >delete</i
                      >
                    </div>
                  }
                </div>
              </div>
            </div>
          </div>
          @if (!member.isPCPSelected) {
            <i
              class="icon icon--medium icon--pointer"
              [data-test-id]="'viewUnselectedProviderIcon' + i"
            >
              chevron_right
            </i>
          }
        </section>
      }
    </div>
  </modal>
}

@if (showFiltersModal) {
  <modal
    [config]="filtersModalConfig"
    [condition]="showFiltersModal"
    (cancel)="toggleFiltersModal.emit()"
    class="ProviderSearchModal"
  >
    <div body class="ProviderSearchModal__Body">
      @for (group of filterGroupConfig; track group; let i = $index) {
        <section>
          @if (group.header) {
            <header>
              <label
                class="t-data t-bold t-caps"
                [innerHTML]="group.header"
                [data-test-id]="'providerFilter_' + i + '_header'"
              ></label>
            </header>
          }
          @for (
            control of group.controls;
            track control;
            let controlIndex = $index
          ) {
            <form-control
              [config]="control"
              [group]="filtersForm"
              [control]="filtersForm.get(control.prop)"
              [data-test-id]="
                'providerFilter_' + i + '_FormControl_' + controlIndex
              "
            >
            </form-control>
          }
        </section>
      }
    </div>
    <div footer class="ProviderSearchModal__Footer">
      <zip-button
        [config]="{
          level: 'medium',
          content: 'Clear Filters',
          size: 'fullWidth',
        }"
        (zipButtonClicked)="reset.emit()"
        data-test-id="providerFilterResetButton"
      ></zip-button>
      <zip-button
        [config]="{ level: 'high', content: 'Filter', size: 'fullWidth' }"
        (zipButtonClicked)="filter.emit()"
        data-test-id="providerApplyFilterButton"
      ></zip-button>
    </div>
  </modal>
}
